import { SettingConst } from '../../types';

/**
 * A comma separated list of UPLT page names to allow rolling out a bug fix one page at a time.
 * Adding a page's name enables a fix for a race-condition in UPLT that incorrectly sets the
 * load type to PAGE_UPDATE
 */
export const UPLT_PAGE_NAMES_ENABLE_PAGE_UPDATE_FIX =
  'UPLT_PAGE_NAMES_ENABLE_PAGE_UPDATE_FIX' as SettingConst<
    'UPLT_PAGE_NAMES_ENABLE_PAGE_UPDATE_FIX',
    string,
    'RETAILER'
  >;
